import empty from '#client/utils/empty';

export function formatName(...props) {
  return props
    .filter((val) => !empty(val))
    .map((val) => val.trim())
    .join(' ');
}

export function formatPhoneNumber(phoneNumberString) {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, ''); // Remove non-digit characters

  // Case: +1XXXXXXXXXX or 1XXXXXXXXXX (International format with/without +)
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }

  // Case: XXXXXXXXXX (Standard US number)
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  return phoneNumberString; // Return original if format doesn't match
}

export const formatSearchParams = (str) =>
  str
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove all special characters except word characters, spaces, and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/--+/g, '-') // Replace multiple consecutive hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens

export function getNameInitials(name) {
  if (!name || typeof name !== 'string') {
    return '';
  }

  const words = name.trim().split(/\s+/);

  if (words.length === 1) {
    const [word] = words;
    return word.substring(0, 2).toUpperCase();
  }

  const [firstWord, secondWord] = words;
  return (firstWord[0] + secondWord[0]).toUpperCase();
}
